import { BUILD_SHA, DOCS_URL, UI_VERSION } from "@/lib/buildInfo";
import { useShellData } from "./shellData";

export function Footer({ onShortcuts }: { onShortcuts: () => void }) {
  const { runtime, adminApi } = useShellData();
  return (
    <footer className="flex h-9 items-center gap-2 border-t px-4 text-xs text-muted-foreground no-print max-md:mb-14">
      <span className="hidden md:inline">
        ATS UI v{UI_VERSION} ({BUILD_SHA}) · Runtime v{runtime.version ?? "—"} · Tester API {runtime.apiVersion ?? "—"} · Admin API:{" "}
        {adminApi === "online" ? "Online" : "Unreachable"} ·{" "}
      </span>
      <span className="md:hidden">
        ATS v{UI_VERSION}
        {DOCS_URL && " · "}
      </span>
      {DOCS_URL && (
        <>
          <a className="hover:text-foreground" href={DOCS_URL} target="_blank" rel="noopener noreferrer">
            Docs
          </a>
          <span className="hidden md:inline">·</span>
        </>
      )}
      <button type="button" className="hidden hover:text-foreground md:inline" onClick={onShortcuts}>
        Shortcuts
      </button>
      <span className="hidden md:inline">· © Atatus</span>
    </footer>
  );
}
